import React from "react";
import { Modal, Button } from "@hid-galaxy-ui/galaxy-react";
import "./Modals.scss";

interface RequirementDescriptionModalProps {
  description: string;
  onClose: () => void;
}

const RequirementDescriptionModal: React.FC<RequirementDescriptionModalProps> = ({
  description,
  onClose,
}) => {
  return (
    <Modal
      headerText="Requirement description"
      width={800}
      onClose={onClose}
      className="requirement-description-modal"
    >
      <div className="modal-content">
        <p className="description-text">{description}</p>
        <div className="modal-footer">
          <Button
            variant="primary"
            label="OK"
            normalCase={true}
            onClick={onClose}
          />
        </div>
      </div>
    </Modal>
  );
};

export default RequirementDescriptionModal;

